import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class RoomTypesService {

    getRoomTypes(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getMasterRoomAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MASTER_ROOM_AMENITIES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getBrandSpecificMasterRoomAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MASTER_ROOM_AMENITIES_BRAND_SPECIFIC
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putRoomTypes(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_ROOM_TYPES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getMasterRoomType(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MASTER_ROOM_TYPES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RoomTypesService()